export default __webpack_public_path__ + "static/media/affordable.45b384ef.svg";